import { createApp } from 'vue';
import SearchPanel from '../components/SearchPanel.vue';

let searchPanelInstance = null;

function initSearchPanel() {
  const mountPoint = document.querySelector('#search-panel-mount');
  
  if (!mountPoint) {
    console.warn('[SearchPanel] Mount point not found');
    return;
  }

  const noResultsImage = mountPoint.getAttribute('data-no-results-image') || '';
  const initialQuery = mountPoint.getAttribute('data-initial-query') || '';

  const app = createApp(SearchPanel, {
    noResultsImage,
    initialQuery
  });

  searchPanelInstance = app.mount(mountPoint);

  window.searchPanelApp = {
    openPanel: () => {
      if (searchPanelInstance && typeof searchPanelInstance.openPanel === 'function') {
        searchPanelInstance.openPanel();
      }
    },
    closePanel: () => {
      if (searchPanelInstance && typeof searchPanelInstance.closePanel === 'function') {
        searchPanelInstance.closePanel();
      }
    },
    getInstance: () => searchPanelInstance
  };

  console.log('[SearchPanel] Initialized');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchPanel);
} else {
  initSearchPanel();
}
